import { z } from "zod";
import { isPhoneComplete } from "@/shared/utils";

export const createCandidateSchema = z.object({
  candidate_name: z.string().min(1, "createForm.candidate_name.error.required"),
  email: z.string().min(1, "createForm.email.error.required").email("createForm.email.error.invalid"),
  phone: z
    .string()
    .min(1, "createForm.phone.error.required")
    .refine(isPhoneComplete, "createForm.phone.error.invalid"),
  job_position: z.string().min(1, "createForm.job_position.error.required").optional(),
  job_position_ru: z.string().min(1, "createForm.job_position.error.required"),
  job_position_kk: z.string().optional(),
  intended_role_id: z.number().optional(),
});

export type CreateCandidateFormValues = z.infer<typeof createCandidateSchema>;
